import api from './../api/authApi'
import useAuth from './useAuth'

const useRefreshToken = () => {
    const {user,setUser}=useAuth()
    const refresh= async ()=>{
        const response=await api.get('token',{
                withCredentials:true
        })
        setUser((prev)=>{
            return {...prev,accessToken:response.data.accessToken}
        })
        return response?.data?.accessToken
    }
  return refresh
}
export default useRefreshToken;